import React, { createContext, useContext, useEffect, useReducer } from 'react'

export const SchemaContext = createContext(null)
export const SchemaReducerContext = createContext(null)

export function SchemaProvider({
  children,
  data,
}) {
  const [state, dispatch] = useReducer(schemaReducer, data)


  useEffect(()=>{
    if(data){
      console.log('initializing schemas', data)
      dispatch({type:'_init', schemas: data || []})
    }
  }, [data])

  return (
    <SchemaContext.Provider value={state}>
      <SchemaReducerContext.Provider value={dispatch}>
        {children}
      </SchemaReducerContext.Provider>
    </SchemaContext.Provider>
  )
}

export function useSchema() {
  return useContext(SchemaContext)
}

export function useSchemaReducer() {
  return useContext(SchemaReducerContext)
}

function schemaReducer(schemas, action) {
  
  console.log('schemas and action', schemas, action)

  switch (action.type) {
    case '_init':
      return action.schemas
    default:
      return schemas
  }
}

// function recordLastActionWrap(controls, action) {
//   return {
//     controls,
//     last_action: action
//   }
// }